var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconReview = function SvgIconReview(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.10293 3.30005C1.7678 3.30005 1.5 3.57044 1.5 3.90005C1.5 8.45743 5.19359 12.15 9.75 12.15C14.3075 12.15 18 8.4563 18 3.90297C18 3.56891 17.7307 3.30005 17.3971 3.30005H2.10293ZM0 3.90005C0 2.74111 0.940274 1.80005 2.10293 1.80005H17.3971C18.5579 1.80005 19.5 2.73927 19.5 3.90297C19.5 9.28492 15.1358 13.65 9.75 13.65C4.36528 13.65 0 9.28598 0 3.90005Z",
    fill: "#8390A1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5501 12.9H7.95005V16.0949C6.92302 16.3034 6.15 17.2114 6.15 18.2999V18.7499H13.35V18.2999C13.35 17.2114 12.577 16.3034 11.5501 16.0949V12.9Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.20005 12.9C7.20005 12.4858 7.53584 12.15 7.95005 12.15H11.5501C11.9643 12.15 12.3001 12.4858 12.3001 12.9V15.5498C13.3595 16.0128 14.1 17.0693 14.1 18.2999V18.7499C14.1 19.1641 13.7642 19.4999 13.35 19.4999H6.15C5.73579 19.4999 5.4 19.1641 5.4 18.7499V18.2999C5.4 17.0692 6.14053 16.0127 7.20005 15.5498V12.9ZM8.70005 13.65V16.0949C8.70005 16.4516 8.44881 16.759 8.09923 16.8299C7.51184 16.9492 7.04932 17.4127 6.93003 17.9999H12.57C12.4507 17.4127 11.9882 16.9492 11.4008 16.83C11.0513 16.759 10.8001 16.4516 10.8001 16.0949V13.65H8.70005Z",
    fill: "#8390A1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.34998 2.1C4.34998 1.35442 4.95439 0.75 5.69998 0.75H13.8C14.5456 0.75 15.15 1.35442 15.15 2.1V8.85C15.15 11.8323 12.7323 14.25 9.74998 14.25C6.76764 14.25 4.34998 11.8323 4.34998 8.85V2.1Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.59998 2.1C3.59998 0.940203 4.54018 0 5.69998 0H13.8C14.9598 0 15.9 0.940201 15.9 2.1V8.85C15.9 12.2466 13.1465 15 9.74998 15C6.35343 15 3.59998 12.2466 3.59998 8.85V2.1ZM5.69998 1.5C5.3686 1.5 5.09998 1.76863 5.09998 2.1V8.85C5.09998 11.4181 7.18185 13.5 9.74998 13.5C12.3181 13.5 14.4 11.4181 14.4 8.85V2.1C14.4 1.76863 14.1313 1.5 13.8 1.5H5.69998Z",
    fill: "#8390A1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.75006 8.57485L8.43175 9.24016C8.13931 9.38775 7.94765 9.25322 8.00337 8.94139L8.25514 7.53223L7.18861 6.53426C6.95202 6.31288 7.02608 6.09633 7.35224 6.05083L8.82615 5.84524L9.48531 4.56314C9.63153 4.27873 9.86895 4.27943 10.0148 4.56314L10.674 5.84524L12.1479 6.05083C12.4748 6.09644 12.5475 6.31342 12.3115 6.53426L11.245 7.53223L11.4968 8.94139C11.5526 9.25399 11.3601 9.38739 11.0684 9.24016L9.75006 8.57485Z",
    fill: "#8390A1"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconReview, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-review.cda35d3b.svg";
export { ForwardRef as ReactComponent };